/* Elegance Coque — icône œil « Aperçu rapide » placée juste sous le cœur Favoris de chaque carte produit,
   dans le même style. Ouvre la fenêtre d'aperçu (assets/ec-quick.js). */
(function () {
 if (window.__ecQuickEye) { return; }
 window.__ecQuickEye = true;
 var d = document, W = window;
 var CARDS = '.lcard,.lcg-card,.ec-p,.lac-card,.lau__card[data-lau-card],.lmk-p,.lwl-card';
 var EYE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/></svg>';
 /* ---------- icône œil sous le cœur ----------
    30-10 : lectures puis écritures groupées (avant : une lecture de mise en page par carte, entre deux écritures,
    ce qui bloquait la page ~0,5 s sur l'accueil). */
 function decorate() {
  var pairs = [];
  [].forEach.call(d.querySelectorAll('.lwl-btn--card[data-lwl]'), function (heart) {
   var card = heart.closest(CARDS) || heart.parentElement;
   if (!card || card.closest('[data-lwl-page]')) { return; }
   var eye = heart.__ecqv;
   if (!eye || !eye.isConnected) {
    var h = heart.getAttribute('data-lwl'); if (!h) { return; }
    var nm = card.querySelector('.lcard__name,.ec-p__name,.lcg-card__title,.lac-card__title,.lau__name,.lmk-p__name,.lwl-card__name,.ecb-card__name');
    eye = d.createElement('button');
    eye.type = 'button'; eye.className = 'lwl-btn ecqv-btn'; eye.setAttribute('data-ecqv', h);
    eye.setAttribute('aria-label', 'Aperçu rapide' + (nm ? ' : ' + nm.textContent.trim() : ''));
    eye.setAttribute('aria-haspopup', 'dialog');
    eye.innerHTML = EYE;
    heart.insertAdjacentElement('afterend', eye);
    heart.__ecqv = eye;
   }
   /* les cartes .lcard sont placées par la feuille de style (assets/ec-30-10.css) : rien à calculer */
   if (!card.classList.contains('lcard')) { pairs.push([eye, heart]); }
  });
  /* 1) toutes les lectures */
  var pos = pairs.map(function (p) {
   var heart = p[1];
   if (!heart.offsetParent) { return null; }
   var cs = W.getComputedStyle(heart);
   return { top: heart.offsetTop + heart.offsetHeight + 8, right: cs.right, left: cs.left };
  });
  /* 2) toutes les écritures */
  pairs.forEach(function (p, i) {
   var v = pos[i], eye = p[0]; if (!v) { return; }
   var top = v.top + 'px';
   if (eye.style.top !== top) { eye.style.top = top; }
   if (v.right !== 'auto') { eye.style.right = v.right; eye.style.left = 'auto'; } else { eye.style.left = v.left; eye.style.right = 'auto'; }
  });
 }
 var decT = 0;
 function later() { W.clearTimeout(decT); decT = W.setTimeout(decorate, 120); }


 d.addEventListener('click', function (e) {
  var b = e.target && e.target.closest && e.target.closest('[data-ecqv]');
  if (!b) { return; }
  e.preventDefault(); e.stopPropagation();
  if (b.getAttribute('aria-busy') === 'true') { return; }
  if (W.ECQuick) { W.ECQuick.open(b.getAttribute('data-ecqv'), b); }
  else { location.href = ((W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(b.getAttribute('data-ecqv')); }
 }, true);
 d.addEventListener('pointerdown', function (e) {
  var b = e.target && e.target.closest && e.target.closest('[data-ecqv]');
  if (b && W.ECQuick) { W.ECQuick.prefetch(b.getAttribute('data-ecqv')).catch(function () {}); }
 }, { passive: true });
 function boot() {
  decorate();
  if (W.MutationObserver) { new MutationObserver(later).observe(d.body, { childList: true, subtree: true }); }
  W.addEventListener('resize', later);
  W.addEventListener('load', later);
 }
 if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
 d.addEventListener('shopify:section:load', later);
})();